import { Observable, map, of, throwError } from "rxjs";
import { ParkerFunctionExecutor } from "./parker-function-executor.class";
import { ParkerClient, ParkerDTO, ParkingSubscriptionClient } from "src/app/base/models/models.swagger.generated";
import { SubscriptionAssignmentFormGroup } from "../../edit-parker-form/edit-parker-edit-subscription-list-form/edit-parker-edit-subscription-list-form.type";
import { DateTime } from "luxon";
import { UpdateParkerUtil } from "./update-parker.util";

export class AdjustSubscriptionExecutor extends ParkerFunctionExecutor {
  private now: DateTime;
  private validFrom: DateTime;
  private validTo: DateTime;

  constructor(numTotalRecordsToWorkOn: number, private subscriptionAssignmentForm: SubscriptionAssignmentFormGroup, private parkingSubscriptionClient: ParkingSubscriptionClient, private parkerClient: ParkerClient) {
    super(numTotalRecordsToWorkOn);
  }

  protected prepare(): Observable<void> {
    return this.parkingSubscriptionClient.getParkingSubscription(this.subscriptionAssignmentForm.controls.subscriptionId.value).pipe(map(sub => {
      this.now = DateTime.now();
      this.validFrom = this.subscriptionAssignmentForm.controls.validFrom.value ? DateTime.fromJSDate(this.subscriptionAssignmentForm.controls.validFrom.value) : this.now;
      this.validTo = this.subscriptionAssignmentForm.controls.validTo.value ? DateTime.fromJSDate(this.subscriptionAssignmentForm.controls.validTo.value) : null;
      if (this.validTo && this.validTo < this.validFrom) {
        this.validTo = this.validFrom;
      }
    }));
  }

  protected executeFunctionOnParker(parker: ParkerDTO): Observable<number> {
      const subscriptionId = this.subscriptionAssignmentForm.controls.subscriptionId.value;
      const updateData = UpdateParkerUtil.createUpdateParkerDTO(parker);
      let existingSubscriptionAssignments = updateData.parkerSubscriptionAssignments?.filter(a => a.subscriptionId === subscriptionId && (a.validTo == null || a.validTo > this.validFrom)) ?? [];
      if (this.validTo != null) {
        existingSubscriptionAssignments = existingSubscriptionAssignments.filter(a => a.validFrom < this.validTo);
      }

      if (existingSubscriptionAssignments.length > 1) {
        return throwError(() => {return {message: 'Multiple intersecting subscriptions found!'}});
      }

      if (existingSubscriptionAssignments.length < 1) {
        return of(parker.id);
      }

      existingSubscriptionAssignments[0].validFrom = this.validFrom;
      existingSubscriptionAssignments[0].validTo = this.validTo;

      return this.parkerClient.updateParker(updateData).pipe(map(parker => parker.id));
  }

  protected preFilterParkersAndUpdateExecutionStatus(parkers: ParkerDTO[]): ParkerDTO[] {
    return parkers; // nothing to filter
  }
}
